/* MAISON MERVAL — interactions du thème */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const overlay = $('[data-overlay]');

  /* ---------- Tiroirs (menu, panier, filtres, guide des tailles) ---------- */
  let openDrawer = null;
  let lastFocus = null;

  function open(drawer) {
    if (!drawer) return;
    if (openDrawer && openDrawer !== drawer) close(openDrawer, false);
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      overlay.hidden = false;
      requestAnimationFrame(() => overlay.classList.add('is-visible'));
    });
    document.body.classList.add('is-locked');
    openDrawer = drawer;
    const focusable = $('button, a, input', drawer);
    if (focusable) setTimeout(() => focusable.focus(), 300);
  }

  function close(drawer = openDrawer, restore = true) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    setTimeout(() => { if (!openDrawer) overlay.hidden = true; }, 300);
    document.body.classList.remove('is-locked');
    openDrawer = null;
    if (restore && lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); open(document.getElementById(opener.dataset.open)); return; }
    if (e.target.closest('[data-close]') || e.target === overlay) { close(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { close(); toggleSearch(false); }
  });

  /* ---------- Bandeau d'annonce ---------- */
  const slides = $$('.announcement__slide');
  if (slides.length > 1) {
    let i = 0;
    setInterval(() => {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, 5000);
  }

  /* ---------- Header au scroll ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Recherche ---------- */
  const searchPanel = $('[data-search-panel]');
  function toggleSearch(force) {
    if (!searchPanel) return;
    const show = force ?? searchPanel.hidden;
    searchPanel.hidden = !show;
    if (show) $('input[type="search"]', searchPanel).focus();
  }
  $$('[data-search-toggle]').forEach((b) => b.addEventListener('click', () => toggleSearch()));

  /* ---------- Menu mobile (accordéon) ---------- */
  $$('[data-mnav-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      btn.nextElementSibling.hidden = expanded;
    });
  });

  /* ---------- Footer : accordéons fermés sur mobile ---------- */
  if (window.matchMedia('(max-width: 989px)').matches) {
    $$('[data-footer-acc]').forEach((d) => d.removeAttribute('open'));
  }

  /* ---------- Apparition au scroll ---------- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  const observeReveal = (root = document) => $$('.reveal:not(.is-in)', root).forEach((el) => io ? io.observe(el) : el.classList.add('is-in'));
  observeReveal();

  /* ---------- Panier ---------- */
  const cartCount = $('[data-cart-count]');

  async function refreshCart(openIt = false) {
    const res = await fetch(`${window.Merval.routes.root_url.replace(/\/$/, '')}/?sections=cart-drawer`);
    const data = await res.json();
    const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const fresh = $('[data-cart-drawer]', html);
    const current = $('[data-cart-drawer]');
    current.innerHTML = fresh.innerHTML;
    const cart = await (await fetch('/cart.js')).json();
    if (cartCount) { cartCount.textContent = cart.item_count; cartCount.hidden = cart.item_count === 0; }
    if (openIt) open(current);
  }

  async function changeLine(line, quantity) {
    const drawer = $('[data-cart-drawer]');
    drawer.style.opacity = '.6';
    await fetch(`${window.Merval.routes.cart_change_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) })
    });
    await refreshCart();
    drawer.style.opacity = '';
  }

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-cart-toggle]');
    if (t && window.Merval.cartType === 'drawer') { e.preventDefault(); open($('[data-cart-drawer]')); }
    if (e.target.closest('[data-look-add]')) return;
    const lc = e.target.closest('[data-line-change]');
    if (lc) changeLine(lc.dataset.lineChange, lc.dataset.qtyTo);
  });
  document.addEventListener('change', (e) => {
    const li = e.target.closest('[data-line-input]');
    if (li) changeLine(li.dataset.lineInput, li.value);
  });

  /* ---------- Fiche produit ---------- */
  const section = $('[data-product-section]');
  if (section) {
    const json = $('[data-product-json]');
    const product = json ? JSON.parse(json.textContent) : null;
    const form = $('[data-product-form]', section);
    const idInput = $('[data-variant-id]', section);
    const addBtn = $('[data-add-btn]', section);
    const addLabel = $('[data-add-label]', section);
    const priceWrap = $('[data-price-wrap]', section);
    const errorEl = $('[data-error]', section);
    const track = $('[data-track]', section);
    const thumbs = $$('[data-thumb]', section);
    const dots = $$('.gallery__dot', section);

    // Galerie
    const goTo = (i) => {
      if (!track) return;
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
    };
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.thumb))));
    if (track) {
      track.addEventListener('scroll', () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
        dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      }, { passive: true });
    }

    // Variantes
    const radios = $$('input[data-option-index]', section);
    const currentOptions = () => {
      const opts = [];
      radios.forEach((r) => { if (r.checked) opts[Number(r.dataset.optionIndex)] = r.value; });
      return opts;
    };
    const setButton = (variant) => {
      if (!addBtn) return;
      if (!variant) { addBtn.disabled = true; addLabel.textContent = 'Indisponible'; return; }
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
    };
    const updateAvailability = (opts) => {
      if (!product) return;
      radios.forEach((r) => {
        const idx = Number(r.dataset.optionIndex);
        const test = [...opts]; test[idx] = r.value;
        const match = product.variants.find((v) => v.options.every((o, n) => o === test[n]));
        r.classList.toggle('is-unavailable', !match || !match.available);
      });
    };
    const onChange = () => {
      const opts = currentOptions();
      const variant = product && product.variants.find((v) => v.options.every((o, n) => o === opts[n]));
      $$('[data-option-label]', section).forEach((el) => { el.textContent = opts[Number(el.dataset.optionLabel)] || ''; });
      updateAvailability(opts);
      setButton(variant);
      if (!variant) return;
      idInput.value = variant.id;
      if (priceWrap) {
        priceWrap.innerHTML = `<div class="price${variant.compare ? ' price--sale' : ''}"><span class="price__current">${variant.price}</span>${variant.compare ? `<s class="price__compare">${variant.compare}</s>` : ''}</div>`;
      }
      const sp = $('[data-sticky-price]');
      if (sp) sp.textContent = variant.price;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      if (variant.media_id && track) {
        const slide = $(`[data-media-id="${variant.media_id}"]`, track);
        if (slide) goTo([...track.children].indexOf(slide));
      }
    };
    radios.forEach((r) => r.addEventListener('change', onChange));
    if (radios.length) updateAvailability(currentOptions());

    // Quantité
    $$('[data-qty]', section).forEach((b) => b.addEventListener('click', () => {
      const input = $('input[name="quantity"]', section);
      input.value = Math.max(1, Number(input.value) + Number(b.dataset.qty));
    }));

    // Ajout au panier
    if (form) {
      form.addEventListener('submit', async (e) => {
        if (window.Merval.cartType !== 'drawer') return;
        e.preventDefault();
        errorEl.hidden = true;
        addBtn.classList.add('is-loading');
        try {
          const res = await fetch(`${window.Merval.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          const data = await res.json();
          if (data.status) throw new Error(data.description || 'Erreur');
          await refreshCart(true);
        } catch (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        } finally {
          addBtn.classList.remove('is-loading');
        }
      });
    }

    // Barre collante mobile
    const sticky = $('[data-sticky-atc]');
    if (sticky && addBtn) {
      const obs = new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      });
      obs.observe(addBtn);
      $('[data-sticky-btn]', sticky).addEventListener('click', () => {
        if (radios.length) { addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        else { form.requestSubmit(); }
      });
    }
  }

  /* ---------- Sélecteurs compacts & ajout groupé (looks, suggestions panier) ---------- */
  const resolvePicker = (qp) => {
    const json = $('[data-qp-json]', qp);
    const idInput = $('[data-qp-id]', qp);
    const selects = $$('[data-qp-option]', qp);
    if (!selects.length) return idInput.value ? { id: Number(idInput.value), available: true } : null;
    const values = selects.map((s) => s.value);
    selects.forEach((s) => s.classList.toggle('is-empty', !s.value));
    if (values.some((v) => !v)) return null;
    const variants = JSON.parse(json.textContent);
    const v = variants.find((x) => x.o.every((o, i) => o === values[i]));
    if (v) idInput.value = v.id;
    return v ? { id: v.id, available: v.a } : null;
  };
  document.addEventListener('change', (e) => {
    const qp = e.target.closest('[data-qp]');
    if (qp) { qp.classList.remove('is-invalid'); resolvePicker(qp); }
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-look-add]');
    if (!btn) return;
    const look = btn.closest('[data-look]');
    const err = $('[data-look-error]', look);
    const items = [];
    let problem = '';

    // Option : inclure le produit principal de la fiche
    if (btn.hasAttribute('data-look-with-main')) {
      const mainId = $('[data-variant-id]');
      const mainBtn = $('[data-add-btn]');
      if (mainId && mainBtn && !mainBtn.disabled) items.push({ id: Number(mainId.value), quantity: 1 });
      else problem = 'Choisissez d\'abord votre taille pour cet article.';
    }
    $$('[data-look-item]', look).forEach((li) => {
      const qp = $('[data-qp]', li);
      if (!qp) return;
      const v = resolvePicker(qp);
      if (!v) { qp.classList.add('is-invalid'); problem = problem || 'Choisissez une taille pour chaque pièce.'; }
      else if (!v.available) { qp.classList.add('is-invalid'); problem = problem || 'Une des tailles choisies est épuisée.'; }
      else items.push({ id: v.id, quantity: 1 });
    });
    if (problem) { err.textContent = problem; err.hidden = false; return; }
    err.hidden = true;
    btn.classList.add('is-loading');
    try {
      const res = await fetch(`${window.Merval.routes.cart_add_url}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const data = await res.json();
      if (data.status) throw new Error(data.description || 'Erreur');
      await refreshCart(true);
    } catch (ex) { err.textContent = ex.message; err.hidden = false; }
    finally { btn.classList.remove('is-loading'); }
  });

  /* ---------- Recommandations produit ---------- */
  const recos = $('[data-recos]');
  if (recos && !recos.children.length) {
    fetch(recos.dataset.url).then((r) => r.text()).then((html) => {
      const el = $('[data-recos]', new DOMParser().parseFromString(html, 'text/html'));
      if (el && el.innerHTML.trim()) { recos.innerHTML = el.innerHTML; observeReveal(recos); }
      else recos.remove();
    });
  }

  /* ---------- Collection : tri & filtres ---------- */
  const sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
  $$('[data-facets-form]').forEach((f) => {
    let timer;
    f.addEventListener('change', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const params = new URLSearchParams(new FormData(f));
        [...params.entries()].forEach(([k, v]) => { if (v === '') params.delete(k); });
        window.location.search = params.toString();
      }, 350);
    });
  });
})();
